// Gives each plotted series a palette color that follows its rank in a
// metric-independent order, so it survives re-sorting by another metric.
// A series keeps the color of its preferred-order index; whoever has no free
// preferred color takes the leftover ones in palette order. With no more series
// than colors, no two share one.
export function assignStableSeriesColors(plottedIds: readonly string[], preferredOrder: readonly string[], palette: readonly string[]): Record<string, string> {
  if (palette.length === 0) return {}

  const preferredIndexById = new Map<string, number>()
  preferredOrder.forEach((id, index) => {
    if (!preferredIndexById.has(id)) preferredIndexById.set(id, index)
  })

  const colorById: Record<string, string> = {}
  const takenIndexes = new Set<number>()
  plottedIds.forEach((id) => {
    const index = preferredIndexById.get(id)
    if (index === undefined || index >= palette.length || takenIndexes.has(index) || id in colorById) return
    colorById[id] = palette[index]
    takenIndexes.add(index)
  })

  const freeIndexes = palette.map((_, index) => index).filter((index) => !takenIndexes.has(index))
  let nextFree = 0
  plottedIds.forEach((id, position) => {
    if (id in colorById) return
    colorById[id] = nextFree < freeIndexes.length ? palette[freeIndexes[nextFree++]] : palette[position % palette.length]
  })

  return colorById
}
